export default __webpack_public_path__ + "static/media/1128040325515394.048b39e4.jpg";